import { getItem, setItem, removeItem } from "../../utils/storageHelper";
export const getTheme = async () => {
  const theme = await getItem("theme");
  return theme || "light";
};

export const setTheme = async (theme) => {
  document.body.setAttribute("data-th-theme", theme);
  await setItem("theme", theme);
};

export const removeTheme = async() => {
   document.body.removeAttribute("data-th-theme");
   await removeItem("theme");
}